import React, { useEffect, useRef, useState } from "react";
import "./ReportMessages.scss";
import { AgingReport, AgingReportBalance, AgingReportMessage, toMonthYear, toPrettyCurrency, toPrettyDate } from "common";
import Select from 'react-select';
import { useUser } from "../store";
import { notify } from "../util/notify";
import ReportMessage from "./ReportMessage";
import { useReports } from "../store/reports";


type ResponseType = {
  id: number;
  text: string;
  sentAt: string;
  deadline?: string;
  recipients: string[];
};

type Thread = {
  id: number;
  text: string;
  sentAt: string;
  deadline?: string;
  targetMonths: string[];
  collapsed: boolean;
  responses: ResponseType[];
};



export default function ReportMessages({ report, onCancel }: { report: AgingReport, onCancel: () => void }) {
  const { invokeApi } = useUser();
  const {
    updateReport,
  } = useReports();

  const [message, setMessage] = useState<string>("");
  const [deadline, setDeadline] = useState<string>("");
  const [months, setMonths] = useState<any[]>([]);
  const [recipients, setRecipients] = useState<string[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [hideZeroBalances, setHideZeroBalances] = useState<boolean>(true);
  const [updatedReport, setUpdatedReport] = useState<AgingReport>(report);
  const inputRef = useRef<any>(null);



  useEffect(() => {
    invokeApi({ endpoint: "/getUsersForNonAdmins" }).then((data: any) => {
      setUsers(data);
    });
  }, []);

  const refreshReport = (report: AgingReport) => {
    setUpdatedReport(report);
    updateReport(report);
  }

  const onSubmit = () => {
    const processedMonths = months.map(m => m.value || m);
    const data = { message, deadline, recipients, months: processedMonths, residentName: updatedReport.residentName, billType: updatedReport.billType, index: updatedReport.index, /*group: updatedReport.group, facility: updatedReport.facility, payer: updatedReport.payer */ };
    if (!data.message) return;
    // if(!data.months?.length) return notify.error("Please select at least one month");
    invokeApi({
      endpoint: "/putReportMessage",
      data,
    }).then((report: AgingReport) => {
      refreshReport(report);;
      notify.success("Message added!");
    });
  };






  const monthCheckboxOptions: any[] = [];
  if (updatedReport?.balances) {
    Object.entries(updatedReport.balances)?.forEach(([month, balance]) => {
      const { history, paid } = balance as AgingReportBalance;
      if (hideZeroBalances && history?.[0] === 0) return;
      monthCheckboxOptions.push({
        value: month,
        label: toMonthYear(month)
      });
    });
  }

  const setMonthDropdown = (months: string[]) => {
    setMonths(months.map(m => monthCheckboxOptions.find((option) => option.value === m)));
  }

  const onReply = (months: string[]) => {
    inputRef?.current?.focus();
    setMonthDropdown(months);
  }

  return (
    <div className="chat-container">
      <div className="chat-header has-background-info">
        <div>
          <div className="title">{updatedReport.residentName} <i className="fa-solid fa-xmark" onClick={onCancel}></i></div>
        </div>
      </div>

      <div className="chat-body">
        {!(updatedReport?.messages?.length) && <div className="no-messages">No messages yet...</div>}
        {updatedReport?.messages?.map((message) =>
          <ReportMessage key={message.id} message={message} parentReport={report} onReply={onReply} refreshReport={refreshReport} />
        )}
      </div>

      <div className="chat-input">
        <textarea
          placeholder="Type your message..."
          ref={inputRef}
          value={message}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            setMessage(e.target.value)
          }
        />

        <div className="input-row">

          <input
            type="date"
            value={deadline}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDeadline(e.target.value)
            }
          />
          <Select placeholder="Recipients" options={users?.map((u: any) => ({ value: u?.username, label: u?.name }))} isMulti={true} menuPlacement="top" onChange={(selected: any) => setRecipients(selected.map((o: any) => o.value))} />
          <Select placeholder="Months" options={monthCheckboxOptions} value={months} isMulti={true} menuPlacement="top" onChange={(selected: any) => setMonths(selected)} />


          <span className="move-right">
            <button className="cancel-btn" onClick={onCancel}>
              Cancel
            </button>
            <button className="send-btn" onClick={onSubmit}>
              Send
            </button>
          </span>
        </div>
      </div>
    </div>
  );
};

